<template>
  <div class="dropdown-group span-1">
    <div class="form-item">
      <label class="form-label">{{ label }}</label>

      <div
          ref="dropdown"
          class="dropdown dropdown-hide-checkbox"
          :class="{ 'dropdown-active': isOpen }"
      >
        <button
            ref="dropdownButton"
            class="dropdown__button"
            :class="{ 'dropdown__button--active': isOpen }"
            type="button"
            :aria-expanded="isOpen.toString()"
            @click="toggleDropdown"
        >
          {{ buttonText }}
        </button>

        <div
            ref="dropdownList"
            class="dropdown__list"
            :class="{ 'dropdown__list--visible': isOpen }"
        >
          <ul ref="dropdownInner">
            <li
                v-for="option in options"
                :key="option.value"
                class="dropdown__list-item"
            >
              <label class="checkbox-label">
                <input
                    :checked="isSelected(option.value)"
                    type="checkbox"
                    :value="option.value"
                    @change="toggleValue(option.value)"
                >
                <span class="fake-checkbox"></span>
                <span class="checkbox-name">{{ option.label }}</span>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div v-if="selectedOptions.length" class="labels-group filter-labels">
      <div
          v-for="option in selectedOptions"
          :key="option.value"
          class="label"
      >
        <span class="font-13">{{ option.label }}</span>
        <span class="label-remove" @click="removeValue(option.value)">
          <svg class="svg-cross">
            <use href="/img/sprite.svg#svg-cross"></use>
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue';
import {useI18n} from "vue-i18n";

export default {
  name: 'MultiSelectFilter',
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Выберите',
    },
  },
  emits: ['update:modelValue'],
  data: () => ({
    isOpen: false,
  }),
  setup() {
    const {t} = useI18n();
    return {t};
  },
  computed: {
    buttonText() {
      if (!this.modelValue.length) {
        return this.placeholder;
      }

      if (this.modelValue.length === 1) {
        const selected = this.options.find(item => item.value === this.modelValue[0]);
        return selected ? selected.label : String(this.modelValue[0]);
      }

      return this.t('modals.selected')+`: ${this.modelValue.length}`;
    },
    selectedOptions() {
      return this.options.filter(item => this.modelValue.includes(item.value));
    },
  },
  mounted() {
    this.onDocumentClick = this.onDocumentClick.bind(this);
    document.addEventListener('click', this.onDocumentClick);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.onDocumentClick);
  },
  methods: {
    async toggleDropdown() {
      this.isOpen = !this.isOpen;

      await nextTick();

      const list = this.$refs.dropdownList;
      const inner = this.$refs.dropdownInner;
      if (!list || !inner) return;

      if (this.isOpen) {
        const contentHeight = inner.scrollHeight;

        // Если высота больше 200px, ограничиваем и включаем прокрутку
        if (contentHeight > 200) {
          list.style.maxHeight = '200px';
          list.style.overflowY = 'auto';
          inner.style.height = 'auto';
        } else {
          // Иначе показываем весь контент без прокрутки
          list.style.maxHeight = (contentHeight + 20) + 'px';
          list.style.overflowY = 'hidden';
          inner.style.height = (contentHeight + 20) + 'px';
        }
      } else {
        list.style.maxHeight = '0';
        list.style.overflowY = 'hidden';
        inner.style.height = '0';
      }
    },
    isSelected(value) {
      return this.modelValue.includes(value);
    },
    async toggleValue(value) {
      const nextValue = this.isSelected(value)
          ? this.modelValue.filter(item => item !== value)
          : [...this.modelValue, value];

      this.$emit('update:modelValue', nextValue);

      await nextTick();

      const list = this.$refs.dropdownList;
      const inner = this.$refs.dropdownInner;
      if (list && inner && this.isOpen) {
        const contentHeight = inner.scrollHeight;

        if (contentHeight > 200) {
          list.style.maxHeight = '200px';
          list.style.overflowY = 'auto';
          inner.style.height = 'auto';
        } else {
          list.style.maxHeight = (contentHeight + 20) + 'px';
          list.style.overflowY = 'hidden';
          inner.style.height = (contentHeight + 20) + 'px';
        }
      }
    },
    async removeValue(value) {
      const nextValue = this.modelValue.filter(item => item !== value);
      this.$emit('update:modelValue', nextValue);

      await nextTick();

      const list = this.$refs.dropdownList;
      const inner = this.$refs.dropdownInner;
      if (list && inner && this.isOpen) {
        const contentHeight = inner.scrollHeight;

        if (contentHeight > 200) {
          list.style.maxHeight = '200px';
          list.style.overflowY = 'auto';
          inner.style.height = 'auto';
        } else {
          list.style.maxHeight = (contentHeight + 20) + 'px';
          list.style.overflowY = 'hidden';
          inner.style.height = (contentHeight + 20) + 'px';
        }
      }
    },
    onDocumentClick(e) {
      const dropdown = this.$refs.dropdown;
      if (!dropdown) return;

      if (!dropdown.contains(e.target)) {
        this.isOpen = false;

        const list = this.$refs.dropdownList;
        const inner = this.$refs.dropdownInner;
        if (list && inner) {
          list.style.maxHeight = '0';
          list.style.overflowY = 'hidden';
          inner.style.height = '0';
        }
      }
    },
  },
};
</script>